export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyCLLbOfebxYMLLksiuJBeiFy98nGB0uFlA',
    authDomain: 'srorganic-9475d.firebaseapp.com',
    projectId: 'srorganic-9475d',
    storageBucket: 'srorganic-9475d.firebasestorage.app',
    messagingSenderId: '117361424226',
    appId: '1:117361424226:web:5050bc812a5b8147b51e3b',
  },
};
